import { create } from 'zustand';
import { getHPCReports, getStudentHPCReports } from '../repositories/hpc/hpcRepo';

export const useHPCStore = create((set, get) => ({
  // State
  hpcReports: [],
  studentHPCReports: [],
  loading: false,
  error: null,

  // Actions
  getHPCReports: async (schoolId) => {
    set({ loading: true, error: null });
      const result = await getHPCReports(schoolId);
      if (result.success) {
        set({ hpcReports: result.value, loading: false });
      } else {
        set({ error: result.message, loading: false });
      }
 
  },

  getHPCStudentReports: async (schoolId, Class, sec, academicYear) => {
    set({ loading: true, error: null });
      const result = await getStudentHPCReports(schoolId, Class, sec, academicYear);
      if (result.success) {
        set({ studentHPCReports: result.value, loading: false });
      } else {
        set({ error: result.message, loading: false });
      }

  },
}));
